export const FeatureName: string = 'user';
